<template>
  <div id="fm_main_app">
    <LayoutMainContainer></LayoutMainContainer>
  </div>
</template>

<script>
import LayoutMainContainer from './components/fm_layout/ContainerMain.vue'

export default {
  name: 'fm_app_container',
  components: {
    LayoutMainContainer
  }
}
</script>

<style>
#fm_main_app {

}
</style>
